import React from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/Footer.scss";
import facebook from "../images/redes/Caralibro.svg"
import Instagram from "../images/redes/Instagram.svg"
import appStore from "../images/App.svg"
import logo from "../images/logoHeader.png"

const Footer = () => {

  return (
    <footer id="contacto">
        <div className="containerFooter">

            <div className="column1">
                <Fade><a href="./index.php"><img src={logo} alt="Logo Coorporativo Salcedo"/></a></Fade>
                <div className="containerTextColumn1">
                    <p>En High Life Language School ofrecemos clases de inglés presenciales para jóvenes y adultos, con atención personalizada y grupos reducidos. Nuestro enfoque práctico garantiza resultados reales en menos tiempo, sin importar tu nivel.</p>
                </div>
            </div>

            <div className="column2">
                <div>
                    <p>NOSOTROS</p>
                    <div className="textColumn2">
                        <a href="#inicio"><span>Conócenos</span></a><br/>
                        <a href="#porqueE"><span>¿Por qué elegirnos?</span></a><br/>
                    </div>
                </div><br/>
                <div>
                    <p>DATOS DE CONTACTO</p>
                    <div className="textColumn2">
                        <a href="mailto:info@highlifelanguageschool.com"><span>Envianos un email</span></a><br/>
                        <a href="tel:+526241270773"><span>624 127 0773</span></a>
                    </div>
                </div>
            </div>
            
            <div className="column3">
                <div>
                    <p>SERVICIOS</p>
                    <div className="textColumn3">
                        <a href="#servicio1"><span>Clases de Inglés para Juniors</span></a><br/>
                        <a href="#servicio2"><span>Clases de Inglés para Jovenes y Adultos</span></a><br/><br/>
                        <span className="ubicacionTitle">INSCRIBETE AHORA</span><br/>
                        <a href="#formContact"><span id="ubicacion">Registrate</span></a><br/>
                    </div>
                </div>
            </div>

            <div className="column4">
                <div>
                    <p>APPS</p>
                    <div>
                        <span>Proximamente</span>
                    </div>
                    <div className="containerImgApp">
                        <img src={appStore} alt=""/>
                    </div>
                </div>
                
                <div className="containerRedes">
                    <Fade cascade="true" direction="left"><a href="https://www.facebook.com/profile.php?id=100063559750121"><img src={facebook} alt="Facebook High Life Language School "/></a></Fade>
                    <Fade cascade="true" direction="left"><a href="https://www.instagram.com/high.life.language.school/"><img src={Instagram} alt="Instagram High Life Language School "/></a></Fade>
                </div>
            </div>

        </div>
</footer>
  );
};

export default Footer;

